export default __webpack_public_path__ + "static/media/skh.e2c736ac.png";